import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ph-guage',
  templateUrl: './ph-guage.component.html',
  styleUrl: './ph-guage.component.css'
})
export class PhGuageComponent{

  @Input()
  gaugeValue: any =0;

  @Input()
  gaugeLabel = "";

  @Input()
  gaugeAppendText = "";

  @Input()
  min=0

  @Input()
  max=14

  @Input()
  thresholds={}

  thresholdConfig = {
    '7': {color: 'green'},
    '0': {color: 'orange'},
    '8': {color: 'red'}
};
}
